import module from 'kendu/legacy/module'
import template from './template.html'
import './style.scss'

export class ComboboxMenuFilterComponent {
  constructor ($element) {
    this.comboboxMenu = undefined
    $element.on('click', ($event) => ($event.stopPropagation()))
  }

  $onInit () {
    this.multiple = this.comboboxMenu.combobox.multiple
  }

  filter () {
    this.comboboxMenu.combobox.filterOptions(this.needle)
  }

  selectAll (selected) {
    this.comboboxMenu.combobox.toggleItems(selected)
  }
}

module.component('comboboxMenuFilter', {
  controller: ComboboxMenuFilterComponent,
  template: template,
  bindings: {
    needle: '<',
  },
  require: {
    comboboxMenu: '^comboboxMenu',
  },
})



// WEBPACK FOOTER //
// ./src/deprecated/directive/combobox/menu-filter/component.js